module.exports = __webpack_public_path__ + "197a9d2042c864c30cc3620f004443bb.svg";